"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crop = exports.getBoxCoordinates = exports.imageBufferToString = exports.imageToBuffer = exports.getImageVersions = exports.getImageUrlVersion = exports.getImageSizes = exports.IMAGE_SIZES = void 0;
exports.IMAGE_SIZES = [
    {
        name: "thumb" /* ImageSize.Thumb */,
        width: 168,
        height: 168,
    },
    {
        name: "mobile" /* ImageSize.Mobile */,
        width: 499,
        height: 499,
    },
    {
        name: "tab" /* ImageSize.Tablet */,
        width: 800,
        height: 800,
    },
    {
        name: "web" /* ImageSize.Web */,
        width: 1200,
        height: 1200,
    },
    {
        name: "largeweb" /* ImageSize.LargeWeb */,
        width: 2500,
        height: 2500,
    },
    {
        name: "original" /* ImageSize.Original */,
        width: Infinity,
        height: Infinity,
    },
];
function getImageSizes({ width, height, }) {
    const sizes = exports.IMAGE_SIZES.filter((size) => {
        return size.height >= height && size.width >= width;
    }).map((size) => size.name);
    return sizes;
}
exports.getImageSizes = getImageSizes;
function getImageUrlVersion(url, width, height) {
    if (url.includes('/original/')) {
        const sizes = getImageSizes({ width, height });
        if (sizes.length > 0) {
            return sizes.map((size) => url.replace('/original/', `/${size}/`));
        }
    }
    return [url];
}
exports.getImageUrlVersion = getImageUrlVersion;
function getImageVersions(url, versions) {
    return versions.map((version) => url.replace('/original/', `/${version}/`));
}
exports.getImageVersions = getImageVersions;
function imageToBuffer(value) {
    const data = value.replace(/^data:\w+\/\w+;base64,/, '');
    return Buffer.from(data, 'base64');
}
exports.imageToBuffer = imageToBuffer;
function imageBufferToString(buffer, contentType) {
    const raw = buffer.toString('base64');
    return `data:${contentType};base64,${raw}`;
}
exports.imageBufferToString = imageBufferToString;
function getBoxCoordinates(element) {
    const coordinates = element.getAttribute('data-box-coordinates');
    if (coordinates) {
        const [x, y, width, height] = coordinates
            .split(' ')
            .map((entry) => Number.parseFloat(entry));
        return {
            x,
            y,
            width,
            height,
        };
    }
    return undefined;
}
exports.getBoxCoordinates = getBoxCoordinates;
function crop(original, mask) {
    return {
        x: mask.x - original.x,
        y: mask.y - original.y,
        width: mask.width,
        height: mask.height,
    };
}
exports.crop = crop;
//# sourceMappingURL=image-utils.js.map